var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoop = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M13.657 9.714v3.715h-1.884c-3.12 0-5.65 2.494-5.65 5.571 0 3.077 2.53 5.571 5.65 5.571h1.883v-3.714L24.96 26.43 13.657 32l-.001-3.715h-1.883c-5.202 0-9.418-4.157-9.418-9.285s4.216-9.286 9.418-9.286h1.884zM26.842 6v3.714h1.884c5.202 0 9.418 4.158 9.418 9.286 0 5.038-4.07 9.14-9.145 9.282l-.273.004h-1.884V24.57h1.884c3.12 0 5.65-2.494 5.65-5.571 0-3.077-2.53-5.571-5.65-5.571l-1.884-.001v3.715L15.54 11.57 26.842 6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.355 0h40v40h-40z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoop);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/loop.d9f7109bd07329f314f49bf3706eb43a.svg";